import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../contexts/AuthContext';
import PhotoRecognitionManagement from '../components/admin/PhotoRecognitionManagement';

const PhotographerPanel = () => {
  const { currentUser } = useAuth();

  return (
    <>
      <Helmet>
        <title>Photographer Portal | Beats of Washington</title>
        <meta name="description" content="Media batch uploader for Beats of Washington photographers." />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-50/80 via-white to-orange-50/20 py-6 sm:py-10">
        <div className="w-full max-w-[1550px] mx-auto px-4 sm:px-6 lg:px-8">
          {/* Core Management Component */}
          <PhotoRecognitionManagement isStandalone={true} user={currentUser} />
        </div>
      </div>
    </>
  );
};

export default PhotographerPanel;
